import * as React from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe"

const url = "https://norse.us5.list-manage.com/subscribe/post?u=45af4a9e452b8f07fb31a7838&amp;id=4ed5bb1aa4&amp;f_id=00c4f9e4f0";

// a basic form
const CustomForm = ({ status, message, onValidated }) => {
    let email;
    const submit = () =>
        email &&
        email.value.indexOf("@") > -1 &&
        onValidated({
            EMAIL: email.value,
        });

    return (
        <div className="flex flex-col items-start justify-center mt-4 gap-4">
            <div className="flex flex-row items-center justify-center gap-4">
                <input
                    className="text-3xl p-4 rounded-md bg-transparent"
                    ref={node => (email = node)}
                    type="email"
                    placeholder="Your email"
                    onKeyDown={(e) => {
                        if (e.key === "Enter") submit();
                    }}
                />
                <button onClick={submit} className="hover:text-blue-900">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-12">
                        <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
                    </svg>
                </button>
            </div>
            {status === "sending" && <div className="text-blue-700">sending...</div>}
            {status === "error" && (
                <div
                    className="text-red-700"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
            {status === "success" && (
                <div
                    className="text-green-700"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
        </div>
    );
};

export default class Subscribe extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="grid grid-cols-1 laptop:grid-cols-2 items-center">
                <img src="/img/Happy group in Alftavatn Hut 1.jpg" className="" />
                <div className="p-16">
                    <h2 className="text-3xl font-bold">JOIN OUR COMMUNITY</h2>
                    <h3 className="text-xl">Exclusive offers, new adventures, and latest stories delivered to your inbox.</h3>
                    <MailchimpSubscribe
                        url={url}
                        render={({ subscribe, status, message }) => (
                            <CustomForm
                                status={status}
                                message={message}
                                onValidated={formData => subscribe(formData)}
                            />
                        )} />
                </div>
            </div>
        )
    }
}
